import { Layer as TilestatsLayer, TilejsonResult } from '@carto/api-client'

export function getTilejsonTilestats(tilejson: TilejsonResult): TilestatsLayer | undefined {
  return tilejson.tilestats?.layers[0]
}

export function getTilejsonGeometryType(tilejson: TilejsonResult) {
  // which one is definitive anyways?
  return getTilejsonTilestats(tilejson)?.geometry || tilejson.vector_layers?.[0]?.geometry_type
}
